<template>
    <client-page>

        <sub-visual
        sh="Machining Products"
        tabActive="CMP Retainer - Ring"
        bg="/images/sub/visual/sv2.png">
        </sub-visual>

        <section class="sub-section sub-section--first">
            <v-container>
                <h2 class="page-tit mb-lg-42">
                    CMP Retainer - Ring
                </h2>
            </v-container>

            <sub-bg-image
            src="/images/sub/products/cmp/cmp-top-img.png"
            className="h-lg-705px">
                <h3 class="tit font-weight-semibold mb-4 mb-lg-16">
                    CMP
                </h3>
                <p class="page-text-lg color-point font-weight-semibold mb-8 mb-md-50 mb-lg-84">
                    Chemical Mechanical Polishing
                </p>
                <p class="page-text color-grey-51 mb-24 mb-lg-50">
                    One of the eight major processes in semiconductor manufacturing. <br>
                    A semiconductor process that polishes the wafer flat using chemical reaction and mechanical force.
                </p>
                <p class="color-point font-size-14 font-size-lg-16 line-height-19 font-weight-bold px-10 px-lg-20 border border-color-point mb-6 mb-lg-14" style="width: fit-content;">
                    Role of Retainer Ring
                </p>
                <p class="font-size-14 font-size-lg-16 color-grey-51 mb-12 mb-lg-24">
                    It is installed on the CMP equipment HEAD, and serves as a guide to prevent the separation of the wafer during the CMP process and to control the uniformity of the wafer.
                </p>
                <p class="color-point font-size-14 font-size-lg-16 line-height-19 font-weight-bold px-10 px-lg-20 border border-color-point mb-6 mb-lg-14" style="width: fit-content;">
                    Type of Retainer Ring
                </p>
                <p class="font-size-14 font-size-lg-16 color-grey-51 mb-4 mb-lg-16">
                    <strong class="font-weight-bold color-point">Two-Body Type</strong> <br>
                    (Metal + Engineering Plastic bonding type) <br>
                    Retainer Ring, which applies bonding technology to metal (SUS 304 or 316) and engineering plastic  (PPS, PEEK and Ect..)
                </p>
                <p class="font-size-14 font-size-lg-16 color-grey-51 mb-4 mb-lg-16">
                    <strong class="font-weight-bold color-point">One-Body Type  </strong> <br>
                    (Engineering Plastic material only –PPS, PEEK and Ect..) <br>
                    An integral retainer ring without bonding made of only one engineering plastic material
                </p>
                <p class="font-size-14 font-size-lg-16 color-grey-51">
                    <strong class="font-weight-bold color-point">Insert Over Molding Type</strong> <br>
                    Retainer ring injection-molded with insert embedded inside
                </p>
            </sub-bg-image>

        </section>

        <section v-if="boards" class="sub-section">
            <v-container>
                
                <slide-primary>
                    <div v-for="board in boards" :key="board._id" class="swiper-slide">
                        <div class="pb-16 pb-lg-30 border-bottom">
                            <div class="thum-wrap">
                                <div class="thum" :style="`background-image: url(${board.thumb})`"></div>
                            </div>
                        </div>
                    </div>
                </slide-primary>

            </v-container>
        </section>

        <section class="sub-section sub-section--last">
            <v-container>
                <inquiry
                src="/images/sub/distributor/dupont/dupont-img1.png"
                name="Kwang Ho, Lee"
                tel="+82-31-765-2268"
                mail="khlee@ist-co.kr"
                fax="+82-31-765-2389">
                </inquiry>
            </v-container>
        </section>

    </client-page>
</template>

<script>
import api from "@/api"
import ClientPage from "@/pages/client/en/templates/ClientPage.vue";
import SubVisual from "@/components/client/en/sub/sub-visual.vue";
import SubBgImage from "@/components/client/en/sub/sub-bg-image.vue";
import SlidePrimary from "@/components/client/en/sub/sub-slide-primary.vue";
import Inquiry from "@/components/client/en/sub/sub-inquiry.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        SubBgImage,
        SlidePrimary,
        Inquiry,
    },
    data() {
        return {
            boards: null
        }
    },
    async mounted() {
        await this.init()
    },
    methods: {
        async init() {
            let { boards } = await api.v1.boards.gets({
                params: { code: "retainer" }
            })
            this.boards = boards;
        }
    }
};
</script>

<style lang="scss" scoped>
</style>